export default __webpack_public_path__ + "static/media/copy.eeae18bb.svg";